import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useIsOwner } from '@/auth/useSession';
import { Card, PageHeader } from '@/components/ui';

/** "More" menu of the bottom bar. */
export function MorePage() {
  const { t } = useTranslation();
  const isOwner = useIsOwner();
  const groups: Array<{ title: string; links: Array<[string, string]> }> = [
    {
      title: t('more.farm'),
      links: [
        ['/reminders', t('reminders.title')],
        ['/breeding', t('breeding.overviewTitle')],
        ['/milk/usage', t('today.milkUsage')],
        ['/events/batch', t('events.batchTitle')],
      ],
    },
    ...(isOwner
      ? [
          {
            title: t('nav.reports'),
            links: [
              ['/dashboard', t('reports.dashboard')],
              ['/reports/monthly', t('reports.monthly')],
              ['/forecast', t('reports.forecast')],
              ['/adoption', t('reports.adoption')],
              ['/export', t('reports.export')],
              ['/partners', t('partners.title')],
              ['/projections', t('projectionSaved.title')],
            ] as Array<[string, string]>,
          },
          { title: t('settings.title'), links: [['/settings', t('settings.title')], ['/settings/users', t('settings.users')]] as Array<[string, string]> },
        ]
      : []),
    {
      title: t('more.app'),
      links: [
        ['/me', t('me.title')],
        ['/sync-issues', t('sync.issuesTitle')],
      ],
    },
  ];
  return (
    <div className="mx-auto max-w-lg space-y-4">
      <PageHeader title={t('nav.more')} />
      {groups.map((g) => (
        <section key={g.title}>
          <h2 className="mb-2 text-sm font-semibold uppercase text-stone-500">{g.title}</h2>
          <Card className="p-0">
            <ul className="divide-y divide-stone-100">
              {g.links.map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="flex min-h-14 items-center justify-between px-4 font-medium">
                    {label}
                    <ChevronRight className="h-5 w-5 text-stone-400" />
                  </Link>
                </li>
              ))}
            </ul>
          </Card>
        </section>
      ))}
    </div>
  );
}
